import React from 'react';
import {
  Box,
  Grid,
  Link,
  Paper,
  Typography,
  LinearProgress,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import { GlobalSiteHealthStatus, Props } from '../Model/HealthModels';
import { healthService } from '../Services/HealthService';
import { StatusIcon, customSort } from '../Common/CommonMethods';

const GlobalHealth = ({ product }: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [globalSitesHealthStatus, setGlobalSitesHealthStatus] = React.useState<
    GlobalSiteHealthStatus[]
  >([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    loadTenantHealthStatus();
  }, [product]);

  const loadTenantHealthStatus = async () => {
    try {
      setLoading(true);
      const globalsites = await healthService.GetGlobalsitesHealth(product);
      setGlobalSitesHealthStatus(globalsites.Items);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        padding: 3,
        borderRadius: 3,
        marginBottom: 3,
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5} mb={3}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '8px',
            bgcolor: 'action.hover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <PublicIcon color="primary" fontSize="small" />
        </Box>
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          fontWeight={700}
          sx={{ letterSpacing: '-0.02em' }}
        >
          Global Health
        </Typography>
      </Box>

      <Box>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4} width="100%">
            <LinearProgress
              sx={{
                width: '100%',
                borderRadius: 3,
                height: 6,
                bgcolor: 'action.selected',
              }}
            />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {globalSitesHealthStatus
              .slice()
              .sort(customSort)
              .map((globalsite) => (
                <Grid item xs={12} sm={6} md={3} lg={2.5} key={globalsite.Id}>
                  <Card
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: `1px solid ${theme.palette.divider}`,
                      bgcolor: 'background.paper',
                      transition:
                        'transform 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: 3,
                      },
                    }}
                  >
                    <CardContent sx={{ p: '16px !important' }}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 600 }}
                        >
                          {globalsite.Id}
                        </Typography>
                        <Link
                          href={globalsite.Url}
                          target="_blank"
                          underline="none"
                          sx={{ display: 'flex' }}
                        >
                          {StatusIcon(
                            globalsite.Status,
                            `${globalsite.ResponseTime}s`,
                          )}
                        </Link>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>
        )}
      </Box>
    </Paper>
  );
};

export default GlobalHealth;
